import fareItemCardBackgroundImageSmallOverlaySimpleCentered from './fareItemCardBackgroundImageSmallOverlaySimpleCentered';

const flavors = {
  fareItemCardBackgroundImageSmallOverlaySimpleCentered
};

export default flavors;
